/* Nexus v22 add-to-cart preloader · Designed by Kavalsia Inc. · Author: Siavash Sadighi
   Markup and styles: snippets/nx-atc-loader.liquid. Live stock: templates/product.nx-stock.liquid */
import { StandardEvents } from '@shopify/events';

const root = document.getElementById('nx-atc');
if (root && !window.__nxAtc) {
  window.__nxAtc = true;
  const UPDATE = StandardEvents.cartLinesUpdate;
  const ERROR = StandardEvents.cartError;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const T = reduce ? { check: 250, add: 200, open: 200, fade: 0 } : { check: 850, add: 700, open: 480, fade: 380 };
  const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const q = (s) => root.querySelector(s);
  const steps = { check: q('[data-step="check"]'), add: q('[data-step="add"]'), open: q('[data-step="open"]') };
  const released = new WeakSet();
  let pdp = null;
  try { const el = document.getElementById('nx-atc-data'); if (el) pdp = JSON.parse(el.textContent); } catch (e) {}
  let busy = false, job = null, lastError = '', passClick = false, sub = '';

  const step = (n, s) => { steps[n].dataset.state = s; };
  const progress = (p) => root.style.setProperty('--p', String(p));
  const say = (text, bad) => { const m = q('[data-nx-atc-msg]'); m.textContent = text || ''; m.hidden = !text; m.classList.toggle('is-bad', !!bad); };
  const setMeta = (n) => { q('[data-nx-atc-meta]').textContent = (sub ? sub + ' \u00b7 ' : '') + 'Quantity ' + n; };

  function show(img, title, qty) {
    Object.keys(steps).forEach((k) => step(k, 'wait'));
    progress(0); say('');
    const im = q('[data-nx-atc-img]'), media = q('.nx-atc__media');
    if (img) { im.src = img; media.hidden = false; } else { im.removeAttribute('src'); media.hidden = true; }
    root.classList.toggle('is-media', !!img);
    q('[data-nx-atc-title]').textContent = title || 'Your selection';
    setMeta(qty);
    root.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
  }
  function hide() { root.classList.remove('is-open'); return wait(T.fade).then(() => { root.hidden = true; }); }
  async function fail(at, text) {
    step(at, 'fail'); say(text, true); root.classList.add('is-fail');
    await Promise.race([wait(3400), new Promise((r) => root.addEventListener('click', r, { once: true }))]);
    root.classList.remove('is-fail');
    await hide();
  }

  function findHandle(pf) {
    const scope = pf.closest('.shopify-section') || document;
    const a = scope.querySelector('a[href*="/products/"]');
    const m = (a ? a.getAttribute('href') : location.pathname).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }
  async function liveStock(handle, vid) {
    if (!handle) return {};
    const url = base + 'products/' + handle;
    try {
      const r = await fetch(url + '?view=nx-stock&_=' + Date.now(), { credentials: 'same-origin' });
      const v = (JSON.parse(await r.text()).v || {})[vid];
      if (!v) return {};
      return { available: v.a, limit: v.m === 'shopify' && v.p === 'deny' ? Math.max(0, v.q) : null };
    } catch (e) {
      try {
        const p = await fetch(url + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const v = p.variants.find((x) => String(x.id) === vid);
        return v ? { available: v.available } : {};
      } catch (e2) { return {}; }
    }
  }
  function cartQty(vid) {
    return fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json())
      .then((c) => c.items.reduce((s, i) => s + (String(i.variant_id) === vid ? i.quantity : 0), 0))
      .catch(() => 0);
  }
  function setQty(pf, form, n) {
    try { const qs = pf.refs && pf.refs.quantitySelector; if (qs && qs.setValue) qs.setValue(n); } catch (e) {}
    let input = form.elements.namedItem('quantity');
    if (input && !(input instanceof HTMLInputElement)) input = input[0];
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = 'quantity'; form.appendChild(input); }
    input.value = String(n);
  }

  function addViaTheme(pf, form, btn) {
    return new Promise((resolve) => {
      job = { pf, resolve, timer: setTimeout(() => { job = null; resolve({ ok: false }); }, 9000) };
      try {
        if (form.requestSubmit) { try { form.requestSubmit(btn); } catch (e) { form.requestSubmit(); } }
        else { passClick = true; btn.click(); passClick = false; }
      } catch (e) { clearTimeout(job.timer); job = null; resolve({ ok: false }); }
    });
  }
  function releaseAndOpen(res) {
    try { released.add(res.event); res.target.dispatchEvent(res.event); }
    catch (e) { location.href = base + 'cart'; return; }
    setTimeout(() => {
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer) { location.href = base + 'cart'; return; }
      const isOpen = typeof drawer.isOpen === 'boolean' ? drawer.isOpen : drawer.hasAttribute('open');
      if (!isOpen && typeof drawer.open === 'function') drawer.open();
    }, 160);
  }

  async function run(pf, form, btn) {
    busy = true; lastError = '';
    let at = 'check';
    const fd = new FormData(form);
    const vid = String(fd.get('id') || '');
    let qty = Math.max(1, parseInt(fd.get('quantity'), 10) || parseInt(pf.dataset.quantityDefault, 10) || 1);
    const mine = pdp && String(pdp.pid) === String(pf.dataset.productId) ? pdp : null;
    const vt = mine && mine.variants ? mine.variants[vid] : '';
    sub = vt && vt !== 'Default Title' ? vt : '';
    const atc = btn.closest('add-to-cart-component');
    const img = ((atc && atc.dataset.productVariantMedia) || '').replace(/([?&])width=\d+/, '$1width=240');
    const heading = (pf.closest('.shopify-section') || document).querySelector('h1, h2, h3');
    show(img, mine ? mine.title : (heading ? heading.textContent.trim() : ''), qty);
    step('check', 'run'); progress(0.14);
    try {
      const [stock, inCart] = await Promise.all([liveStock(mine ? mine.handle : findHandle(pf), vid), cartQty(vid), wait(T.check)]);
      if (stock.available === false) return await fail('check', 'This piece has just sold out.');
      if (stock.limit != null) {
        const left = stock.limit - inCart;
        if (left <= 0) return await fail('check', inCart > 0 ? 'Every piece we have of this is already in your cart.' : 'This piece has just sold out.');
        if (qty > left) { qty = left; setQty(pf, form, qty); setMeta(qty); say('Only ' + left + ' left in stock, so we\u2019re adding ' + left + '.'); }
      }
      step('check', 'done'); progress(0.45);
      at = 'add'; step('add', 'run');
      const t0 = Date.now();
      const res = await addViaTheme(pf, form, btn);
      await wait(Math.max(0, T.add - (Date.now() - t0)));
      if (!res.ok) return await fail('add', lastError || 'We couldn\u2019t add this to your cart. Please try again.');
      step('add', 'done'); progress(0.8);
      at = 'open'; step('open', 'run');
      await wait(T.open);
      step('open', 'done'); progress(1);
      await wait(reduce ? 0 : 240);
      hide();
      releaseAndOpen(res);
    } catch (err) {
      console.warn('[nx-atc]', err);
      await fail(at, 'Something went wrong. Please try again.');
    } finally {
      btn.dataset.puppet = 'false';
      busy = false;
    }
  }

  /* Hold the theme's cart event until the panel is done, so the drawer opens after it rather than on click */
  window.addEventListener(UPDATE, (e) => {
    if (!job || released.has(e)) return;
    const t = e.target;
    if (!(t instanceof Node) || !(t === job.pf || job.pf.contains(t))) return;
    e.stopImmediatePropagation();
    const j = job; job = null; clearTimeout(j.timer);
    Promise.resolve(e.promise).then(
      (r) => j.resolve({ ok: !(r && r.detail && r.detail.didError), event: e, target: t }),
      () => j.resolve({ ok: false })
    );
  }, true);

  window.addEventListener(ERROR, (e) => {
    const d = e.detail || {};
    const pick = [d.detail && d.detail.description, d.description, d.error, e.error];
    lastError = pick.find((x) => typeof x === 'string' && x.trim()) || lastError;
  }, true);

  window.addEventListener('click', (e) => {
    if (passClick) return;
    const btn = e.target && e.target.closest ? e.target.closest('product-form-component [ref="addToCartButton"]') : null;
    if (!btn || btn.closest('dialog')) return;
    const pf = btn.closest('product-form-component');
    const form = btn.form || btn.closest('form');
    if (!pf || !form) return;
    if (busy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (btn.disabled || !form.checkValidity()) return;
    try { const qs = pf.refs && pf.refs.quantitySelector; if (qs && qs.canAddToCart && !qs.canAddToCart().canAdd) return; } catch (err) {}
    e.preventDefault();
    e.stopImmediatePropagation();
    run(pf, form, btn);
  }, true);
}